import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_chat",
  class: "bg-white w-50",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "chat",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-cid": "0",
  "data-kt-drawer-toggle": "#kt_drawer_chat_toggle",
  "data-kt-drawer-close": "#kt_drawer_chat_close"
}
const _hoisted_2 = {
  class: "card w-100",
  id: "kt_drawer_chat_messenger",
  style: {"max-width":"800px","height":"fit-content"}
}
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body p-0" }
const _hoisted_6 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_7 = {
  class: "table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9",
  id: "kt_api_keys_table"
}
const _hoisted_8 = { class: "border-gray-200 fs-5 fw-bold bg-lighten" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "min-w-125px min-w-125px" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", { class: "" }, null, -1)
const _hoisted_19 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_20 = { class: "text-gray-600" }
const _hoisted_21 = { class: "text-gray-600" }
const _hoisted_22 = { class: "text-gray-600" }
const _hoisted_23 = { class: "text-gray-600" }
const _hoisted_24 = { class: "text-gray-600" }
const _hoisted_25 = { class: "text-gray-600" }
const _hoisted_26 = { class: "text-gray-600" }
const _hoisted_27 = { class: "text-gray-600" }
const _hoisted_28 = { class: "text-gray-600" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  style: {"color":"#007bff"},
  class: "text-primary primary svg-icon svg-icon-2x"
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "alert alert-warning d-flex align-items-center p-5 my-10 mx-10" }
const _hoisted_33 = { class: "svg-icon svg-icon-2hx svg-icon-warning me-4" }
const _hoisted_34 = { class: "d-flex flex-column" }
const _hoisted_35 = { class: "mb-1 text-warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserData = _resolveComponent("UserData")!
  const _component_AbsenceDetails = _resolveComponent("AbsenceDetails")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UserData, { onAllStudentData: _ctx.setStudenInfo }, null, 8, ["onAllStudentData"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AbsenceDetails, { courseAbsenceDetailsRes: _ctx.courseAbsenceDetailsRes }, null, 8, ["courseAbsenceDetailsRes"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.courseAttendanceRes && _ctx.courseAttendanceRes.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _createElementVNode("thead", _hoisted_8, [
                    _createElementVNode("tr", _hoisted_9, [
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.translate("courseAttendance.courseCode")), 1),
                      _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.translate("courseAttendance.courseName")), 1),
                      _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.translate("courseAttendance.absenceNo")), 1),
                      _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.translate("courseAttendance.absencePer")), 1),
                      _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.translate("courseAttendance.excuseNo")), 1),
                      _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.translate("courseAttendance.excusePer")), 1),
                      _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.translate("courseAttendance.absenceTimes")), 1),
                      _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.translate("courseAttendance.warningNo")), 1),
                      _hoisted_18
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseAttendanceRes, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "text-center",
                        key: index
                      }, [
                        _createElementVNode("td", _hoisted_20, _toDisplayString(item.courseCode), 1),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(item.courseDescr), 1),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(item.studAbs), 1),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(item.studAbsPrcnt), 1),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(item.studAbsExecuse), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(item.studAbsExecPrcnt), 1),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(item.absCount), 1),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(item.seqNo), 1),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("div", {
                            "data-kt-drawer-toggle": "true",
                            "data-kt-drawer-target": "#kt_drawer_chat",
                            onClick: ($event: any) => (_ctx.openDrawer(item.edCourseId)),
                            style: {"cursor":"pointer","color":"#5867dd"},
                            title: "Show more details"
                          }, [
                            _createElementVNode("span", _hoisted_30, [
                              _createVNode(_component_inline_svg, {
                                style: {"color":"#007bff"},
                                src: "media/icons/duotune/files/fil001.svg",
                                class: "text-primary bluecolor"
                              })
                            ])
                          ], 8, _hoisted_29)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.courseAttendanceRes && _ctx.courseAttendanceRes.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("h4", _hoisted_35, _toDisplayString(_ctx.translate("courseAttendance.noAbsence")), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}